<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:32:15
 * @LastEditors: daikeyi
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <div id='main-container' class="main-container">
                <van-pull-refresh :class="{flexClass:!listShow}" v-model="isLoading" @refresh="onRefresh" class='refreshStyle'>
                    <van-list v-model="ploading" :finished="finished"  @load="onLoad" :offset="1">
                        <div v-if='listShow'>
                            <van-swipe-cell :right-width="65" class="goods" v-for="(good, index) in goods" :key="index.goodscode">
                                <div @click.stop="godetail(good)">
                                    <goodCommon :good="good"></goodCommon>
                                </div>
                                <span slot="right" @click='clickDelete(good)'>
                                    删 除
                                </span>
                            </van-swipe-cell>
                        </div>
                        <div v-if='!listShow' class='text-center'>
                            <img :src="noListUrl" alt="">
                            <p class='noCollection'>暂无收藏！</p>
                        </div>
                    </van-list>
                     <listBottom v-if='finishedOk && bottomShow'></listBottom>
                     <div class="placeholder"></div>
                </van-pull-refresh>
            </div>
        </div>
    </div>
</template>
<script>
import goodCommon from '@/components/common/goodCommon';
import { toastLoading, clearToastLoading, confirmModal } from '@/utils/base/utils';
import listBottom from '@/components/common/listBottom';

export default {
    components: {
        goodCommon,
        listBottom
    },
    data() {
        return {
            goods: [],
            isLoading: false,
            goodId: '',
            listShow: true,
            noListUrl: require('../assets/img/myCenter/noList.png'),
            pageSize: 5,
            pageNum: 1,
            ploading: false,
            finished: true,
            finishedOk: false,
            bottomShow: false
        };
    },
    esvReady() {
        console.log(111);
        document.title = '收藏列表';
        this.queryCollectionList();
    },
    esvShow() {},
    methods: {
        // 查询收藏
        queryCollectionList: function() {
            const self = this;
            this.finished = true;
            this.bottomShow = false;
            self.$doRequest(
                {
                    url: '/collection/queryMemberShippingCollectionList',
                    params: {
                        pageSize: self.pageSize,
                        pageNum: self.pageNum
                    },
                    before: function() {
                        self.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(self.loading);
                        self.finished = true;
                        self.ploading = false;
                        self.bottomShow = true;
                    }
                },
                function(data) {
                    if (data.result.list !== undefined) {
                        self.goods =
                        self.pageNum === 1
                            ? data.result.list
                            : [...self.goods, ...data.result.list];
                    }
                    if (self.goods.length < data.result.total) {
                        self.finished = false;
                    } else {
                        self.finished = true;
                        self.finishedOk = true;
                    }
                    if (self.goods.length > 0) {
                        self.listShow = true;
                    } else {
                        self.finishedOk = false;
                        self.listShow = false;
                    }
                    self.isLoading = false;
                    data.result.list !== undefined && data.result.list.length > 0
                        ? (self.listShow = true)
                        : (self.listShow = false);
                }
            );
        },
        // 上拉加载
        onLoad() {
            console.log('上拉加载');
            this.pageNum++;
            this.queryCollectionList();
        },
        onRefresh() {
            this.pageNum = 1;
            this.queryCollectionList();
        },
        onClose(clickPosition, instance) {
            switch (clickPosition) {
            case 'left':
            case 'cell':
                instance.close();
                break;
            case 'outside':
                instance.close();
                break;
            case 'right':
                confirmModal('确定删除吗？', function() {
                    instance.close();
                });
                break;
            }
        },
        clickDelete(good) {
            const ths = this;
            ths.goodId = good.productId;
            confirmModal('确定删除吗？', function() {
                ths.$doRequest(
                    {
                        url: '/collection/cancelMemberShippingCollection',
                        params: {
                            productId: ths.goodId
                        },
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                        }
                    },
                    function(data) {
                        if (data.responseCode === '100000') {
                            ths.queryCollectionList();
                        }
                    }
                );
            });
        },
        godetail: function(good) {
            const ths = this;
            if (good.isMarketable === 1) {
                return false;
            }
            ths.ESVStorage.putSavedValue('goodsId', good.productId);
            ths.esvOpenPage('OPGoodsdetail');
        }
    }
};
</script>
<style lang="scss" scoped>
.van-pull-refresh {
    padding-bottom: 0!important;
}
// .goods {
//     height: 138px;
//     background: #fff;
//     clear: both;
//     .van-cell {
//         padding: 0;
//     }
//     .van-swipe-cell__right {
//         width: 100%;
//         span {
//             display: inline-block;
//             width: 100%;
//         }
//     }
// }
.refreshStyle {
    height: 100%;
    overflow: auto;
}
.text-center {
    text-align: center;
    img {
        width: 203px;
    }
}
.noCollection {
    color: #999;
    padding-top: 20px;
    text-align: center;
}
</style>
